import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export const revalidate = 0;

const ContattiPage =  () => {
    const { t } = useTranslation();

    return (
        <div>
            <h1 className="text-4xl font-light text-gray-800 titolo mb-4 text-center">
                {t("contatti.titolo")}
            </h1>

            <div className="grid grid-cols-1 space-y-8 lg:grid-cols-2 lg:space-x-8 lg:space-y-0 my-auto lg:h-52" >
                <motion.div 
                    className="p-8 rounded-2xl text-center shadow-lg shadow-verde_scuro h-full "
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <h2 
                        className="text-xl font-medium mb-4"
                        dangerouslySetInnerHTML={{ __html: t("contatti.azienda_nome") }}
                    />
                    <a className="text-lg font-normal" href="https://maps.app.goo.gl/ZT4SY32yuB1hb1Ws9"> {t("contatti.azienda_indirizzo")}</a>
                   
                </motion.div>
                <motion.div 
                    className=" p-8 rounded-2xl text-center shadow-lg shadow-verde_scuro h-full"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <h2 className="text-xl font-medium mb-4">{t("contatti.contattaci_titolo")}</h2>
                    <p className="text-lg ">
                        {t("contatti.email_label")} <a href="mailto:info@beverahills.it" className="text-rosso font-semibold underline">info@beverahills.it</a>
                    </p>
                    <p className="text-lg mt-2">
                        Giuseppe: <a href="tel:+393358347925" className="font-semibold text-rosso">+39 335 834 7925</a>
                    </p>
                    <p className="text-lg mt-2">
                        Luca: <a href="tel:+393317375660" className="font-semibold text-rosso">+39 331 737 5660</a>
                    </p>
                </motion.div>
            </div>

             <iframe 
                    className="mt-16 lg:mt-8 rounded-xl"
                title="Mappa sede Azienda Agricola Beverahills"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6662.379604303019!2d9.328273876642212!3d45.754248614038936!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786a6785caac907%3A0xd21594eabbc435a9!2sAzienda%20Agricola%20Beverahills!5e1!3m2!1sit!2sit!4v1760184517532!5m2!1sit!2sit"
                     width="100%"
                      height="400" 
                        style={{ border: 0 }}
                      allowFullScreen="" 
                      loading="lazy" 
                      referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
    );
};

export default ContattiPage;